import PropTypes from 'prop-types';
import { useEffect } from 'react';

import history from 'util/History';

import Route from './common/Routes.js';

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state
const GCPInputConfiguration = ({ url }) => {
  useEffect(() => {
    history.push(url);
  }, []);

  return null;
};

GCPInputConfiguration.propTypes = {
  url: PropTypes.string,
};

GCPInputConfiguration.defaultProps = {
  url: Route.INTEGRATIONS.GCP.ACTIVITYAPI.index,
};

export default GCPInputConfiguration;
